import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { Proxy } from '../../services/proxy/proxy.service';

@IonicPage()
@Component({
  selector: 'page-modal-codigo-amonestacion',
  templateUrl: 'modal-codigo-amonestacion.html',
})
export class ModalCodigoAmonestacionPage {

  //#region Propiedades del controlador
  public listaCodigos: Proxy.ListaPrCodigoAmonestacion;
  public filtro: string = "";
  //#endregion

  constructor(public navCtrl: NavController, public navParams: NavParams, private viewCtrl: ViewController) {
  }

  ionViewDidLoad() {
    this.listaCodigos = <Proxy.ListaPrCodigoAmonestacion>this.navParams.get("codigos");
  }

  //#region  Métodos del controlador
  public CodigoSeleccionado(codigo: Proxy.PrCodigoAmonestacion): void {
    this.viewCtrl.dismiss(codigo);
  }

  public FiltradoCancelado(event: any): void {
    console.log('Filtrado cancelado');
    this.filtro = '';
  }
  //#endregion
}



// WEBPACK FOOTER //
// ./src/pages/modal-codigo-amonestacion/modal-codigo-amonestacion.ts